export default "__VITE_ASSET__Cl93DJgK__"